import { render, staticRenderFns } from "./NirCompensationAgreementsPage.vue?vue&type=template&id=3ad52992&scoped=true"
import script from "./NirCompensationAgreementsPage.vue?vue&type=script&lang=js"
export * from "./NirCompensationAgreementsPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ad52992",
  null
  
)

export default component.exports